module.exports = __webpack_public_path__ + "static/protectas-8bec5f666546c89e49c485540d21bd1e.png";